import {Popover, Row} from "antd";
import {UserSelectWidget} from "./UserSelectWidget";

export const FollowerSelectWidget = ({onApiFail, refresh, onRefresh, followers, addFollower, removeFollower, disabled=false, props}) => {

    const _addFollower = (follower) => {
        if (addFollower) {
            addFollower(follower);
        }
    }

    const _removeFollower = (follower) => {
        if (removeFollower) {
            removeFollower(follower);
        }
    }

    const onFollowerClick = (follower) => () => {
        if (disabled === true) {
            return;
        }
        _removeFollower(follower);
    }

    const listStyle = {
        cursor: 'pointer',
        color: "#108ee9",
        marginLeft: '5px',
        marginRight: '5px'
    }
    const followerList = followers.map((f, index) => {
        let comma = (index !== followers.length-1) ? "," : ""
        const name = `${f.firstname} ${f.lastname}`
        return <Popover key={f.id} content={`Remove ${name}`}>
            <div onClick={onFollowerClick(f)} style={listStyle}>{`${name}${comma}`}</div>
        </Popover>
    })

    const rowStyle={
        marginTop: '5px',
        marginBottom: '5px'
    }
    return <div>
        <Row style={{marginBottom: '5px'}}>{followerList}</Row>
        <Row style={rowStyle}><UserSelectWidget onApiFail={onApiFail} type={"button"} setUser={_addFollower} disabled={disabled}/></Row>
    </div>
}